import React from "react";

export const Page8Tamil = () => {
  return (
    <div className="page-tamil-container">
      <p>
        புதிய சிலையாக கட்டுச் அமைக்க தீர்மானித்தோம். பல்லாண்டுகள் பழுது
        ஏற்படாமல் இருக்க கம்பி கட்டு, சிமெண்ட், மற்றும் பொருட்களைக் கொண்டு
        சிலையை அமைத்தோம். கருணை பொழியும் கண்கள் வேண்டும் என்றார்கள். என்ன
        செய்யலாம் என்ற எண்ணத்தில் இருந்த எனக்கு கரூரில் உள்ள ஒரு ஸ்தாபனத்தில்
        சிலைகளுக்கு வைக்கக் கூடிய ஒளிரும் கண்களை செய்து தருவதாக அறிந்தேன். முக
        அமைப்புக்குக் கேற்ற கண்களை தேர்ந்தெடுக்க என்னையே அனுப்பினார்கள்.
        ரூ.5,000/- விலையில் இரண்டு கண்கள் வாங்கி வந்தேன். பிறகு தான் எனக்கு கவலை
        அதிகமானது - கண்களை பொறுத்துவதில் தவறு ஏற்பட்டால் மேல் பார்வை கூடாது
        கீழ்நோக்கி பார்வையும் கூடாது இரண்டு கண்களும் ஒரே மாதிரி அமைய வேண்டும்
        இல்லாவிட்டால் மாறு கண்ணாக போய்விடும்.
      </p>
      <p>
        இதையெல்லாம் யோசித்து ஒரு நாள் பகல் பொழுதிலும், இரவில் வெளிச்சத்திலும்
        எப்படி இருக்கிறது என்ற பார்க்க இரவிலும் தொடர்ந்து கவனமாக கண்களை
        பொருத்தினேன். சிலைக்கேற்ற வண்ணம் தீட்ட வேண்டுமென்று நினைத்தபோது நண்பர்.
        S. தியாகு அவர்களையும் நினைத்தேன். பணியை ஏற்றார்கள் - என் எண்ணத்திற்கேற்ற
        வண்ணம் தீட்டித் தந்திருக்கிறார்கள்.
      </p>
      <p>
        பார்த்தார் பழுதடைந்த கோயில் ஒன்று அவர் கண்ணுக்கு பட்டது உள்ளே
        புகுந்தார். கோயிலில் ஒழுகாத இடமாக சிவனுக்கு மேலே உள்ள கூரை மட்டுமே
        இருந்தது. சுவாமிக்கு பக்கத்திலேயே அமர்ந்தார். தூக்கம் வரவில்லை பக்திமான்
        ஆதலால் அந்தக் கோயிலுக்கு எப்படி திருப்பணி செய்யலாம் என்று திட்டமிட்டார்.
        வானுயர ராஜகோபுரம் கட்டுவேன், மதில் சுவர் எடுப்பேன், கர்ப்பக் கிரக
        விமானத்திற்கு சிற்பங்களை எவ்வாறு அமைக்கலாம். சுவாமிக்கு பூஜை செய்ய நீர்
        எடுக்க திருக்குளம் அமைப்பது - பூவெடுத்து அர்ச்சிக்க நந்தவனம் அமைப்பது -
        இத்தனை திருப்பணிகளும் முடிந்த பிறகு கும்பாபிஷேகத்தை எப்படி சிறப்பாக
        செய்யலாம் என்று இரவு முழுவதும் திட்டம் போட்டுக் கொண்டே இருந்தார்.
      </p>
      <p>
        உத்தமனின் ஆயுள் நியதிப்படி காலன் கட்டளையால் அன்று நடுச்சாமத்தில் அவர்
        உயிரைப் பறிக்க கருநாகம் ஊர்ந்து வந்தது. அதைக் கண்ட சிவன் கழுத்திலுள்ள
        நாகப்பாம்பு கருநாகத்திற்கு ஒரு எச்சரிக்கை விடுத்தது. இங்கே உள்ள பக்தன்
        பெருமானுக்கு பெருங்கோயில் கட்ட திட்டமிட்டுக் கொண்டிருக்கிறார் சிவனார்
        அவர் பேரில் மகிழ்வோடு இருப்பதோடு அவர் மேல் கோயில் கூரை விழாமல் தன்
        தலையால் தாங்கிக் கொண்டிருக்கிறார். நிலைமை இவ்வாறிருக்க நீ அவரைத்
        தீண்டினால் தெய்வ கோபத்திற்கு ஆளாக நேரிடும் திரும்பப் போய்விடு என்று
        எச்சரித்தது. கருநாகமும் அவரைத் தீண்டாமல் திரும்பி விட்டது.
      </p>
      <p>
        பொழுது புலர்ந்தது மழையும் விட்டது அவர் கோயிலை விட்டு வெளியே வந்தார்.
        கோயிலும் இடிந்து விழுந்தது. இறைவன் அருளால் அவரது உயிர் இருமுறையும்
        தப்பித்தது
      </p>
    </div>
  );
};
